import { useEffect, useState } from 'react';
import moment from 'moment/moment';
import { useHistory } from 'react-router-dom';
import { Image } from 'antd';
import { parseFileUrl } from 'src/utils/urlUtils';
import NameIcon from 'src/components/NameIcon';
import ListView from '../components/ListView';
import { getChatHistoryListAPI } from '../../../api/conversation';
import { getTopicRecordAPI } from '../../../api/backstage';
import TopicIcon from 'src/components/TopicIcon';

const Icon = (icon, name) => (
  <div
    style={{
      width: '20px',
      height: '20px',
      borderRadius: '6px',
      overflow: 'hidden',
      fontSize: '6px',
    }}
  >
    {icon ? (
      <Image src={parseFileUrl(icon)} preview={{ mask: false }} />
    ) : (
      <NameIcon style={{ borderRadius: '4px' }} name={name} />
    )}
  </div>
);

const ChatView = ({ user }) => {
  const getTopic = async () => {
    const {
      json: { result },
    } = await getTopicRecordAPI();
    return result;
  };

  const [query, setQuery] = useState({
    page: 1,
    page_size: 4,
    user_id: user.userId,
  });
  const [type, setType] = useState('list');
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const getList = async topicList => {
    const {
      json: {
        result: { result },
      },
    } = await getChatHistoryListAPI(query);
    const list = result.map(r => {
      let icon;
      const topic = r.topic ? Number(r.topic) : null;
      if (topic && !isNaN(topic)) {
        const target = topicList.find(x => x.id === topic);
        if (target) {
          icon = TopicIcon({ topicInfo: target, size: 20, className: '!text-[6px]' });
        }
      } else {
        icon = null;
      }
      return {
        ...r,
        date: moment(r.time).format('YYYY-MM-DD HH:mm'),
        icon,
      };
    });
    setList(list);
    setTotal(list.length);
  };
  useEffect(() => {
    getTopic().then(topicList => {
      getList(topicList);
    });
  }, [query.page, query.page_size]);
  const [activeTab, setActiveTab] = useState(1);
  const tabs = [{ label: '最近创建', value: 1 }];
  const tabChange = tab => {
    if (tab === activeTab) return;
    setActiveTab(tab);
  };

  const history = useHistory();
  /**
   * 查看更多
   */
  const onMore = () => {
    history.push('/chat');
  };
  /**
   * 查看详情
   * @param chat
   */
  const onDetail = chat => {
    history.push(`/chat?conversation_id=${chat.conversation_id}`);
  };
  useEffect(() => {
    if (type === 'card') {
      setQuery({ ...query, page_size: 4 });
    }
    if (type === 'list') {
      setQuery({ ...query, page_size: 4 });
    }
  }, [type]);
  return (
    <ListView
      title="对话"
      activeTab={activeTab}
      tabs={tabs}
      tabChange={tabChange}
      moreText="查看所有"
      onMore={onMore}
      list={list}
      type={type}
      onTypeChange={type => setType(type)}
      onDetail={onDetail}
      current={query.page + 1}
      pageSize={query.page_size}
      total={total}
      onPageChange={page => setQuery({ ...query, page: page - 1 })}
    />
  );
};

export default ChatView;
